import { useContext } from 'react';
import { ThemeContext } from '../../../contexts/ThemeContext';

// Lastebil-ink følger appens lyse/mørke tema; faller tilbake til 'light' uten ThemeProvider (tester).
export default function useTruckTheme() {
  return useContext(ThemeContext)?.resolvedTheme ?? 'light';
}
